import * as React from 'react';
import Loader from '../../components/Loader';
import NotFound from '../NotFound';
import Order from './Order';
import { useRequest, getHeaders } from '../../api/client';
import { ProfileContext, ProfileManager } from '../../profile';
import { RouteComponentProps } from 'react-router';

const order = (id: string, context: ProfileManager) => {
  const [state, _] = useRequest(() => ({
    url: `/store/orders/${id}`,
    method: 'GET',
    headers: getHeaders(context),
  }));

  return state;
};

const getStateEntity = (props: RouteComponentProps<any>) => {
  return props.location.state ? props.location.state.order : null;
};

const getEntityID = (props: RouteComponentProps<any>) => {
  return props.match.params.id;
};

export function withState(Component: any) {
  return (props: RouteComponentProps<any>) => {
    const context = React.useContext(ProfileContext);
    const preloadedEntity = getStateEntity(props);

    if (preloadedEntity) {
      return <Component order={preloadedEntity} />;
    }

    const state = order(getEntityID(props), context);

    if (state.loading || !state.data) {
      return <Loader />;
    }

    if (state.error) {
      return <NotFound />;
    }

    return <Component order={state.data} />;
  };
}

export default withState(Order);
